import { makeStyles } from "@mui/styles";

export default makeStyles((theme) => ({
  profilecontainer: {
    backgroundColor: "#F5F6F7",
    width: "100%",
    height: 258,
    marginTop: 20,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 22
  },
  pickercontainer: {
    position: "absolute",
    backgroundColor: theme.palette.primary.main,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "25px",
    height: "25px",
    bottom: 0,
    right: 0,
    color: "white",
    borderRadius: "50%"
  },
  camera: {
    color: "white",
    width: "14px!important"
  },
  profilepicker: {
    opacity: 0,
    width: 25,
    height: 25,
    cursor: "pointer",
    position: "absolute"
  },
  imageviewer: {
    width: "150px",
    height: "150px",
    backgroundColor: "white",
    borderRadius: "50%",
    position: "relative",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  profileform: {
    // width: "70%!important",
    [theme.breakpoints.up("lg")]: {
      width: "100%!important"
    }
  },
  btnspace: {
    marginTop: "30px",
    paddingLeft: "16px",
    "@media (max-width: 600px)": {
      marginTop: "20px",
      marginLeft: 0,
      paddingLeft: "16px",
      display: "flex",
      justifyContent: "center",
      flexDirection: "row",
      width: "100%"
    }
  },
  downloadbutton: {
    marginTop: 20,
    textAlign: "center"
  },
  whitebg: {
    background: "white",
    borderRadius: "10px"
  },
  // SIGNATURE
  signatureWrap: {
    width: "100%"
  },
  signatureLabel: {
    fontSize: 14,
    fontWeight: 500,
    marginBottom: 8,
    textAlign: "left",
    color: "#1f2937"
  },
  signatureCard: {
    position: "relative",
    width: "100%",
    minHeight: 140,
    background:
      "repeating-linear-gradient(0deg, #f8fafc, #f8fafc 12px, #f1f5f9 12px, #f1f5f9 24px)",
    border: "1px solid #e5e7eb",
    borderRadius: 16,
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 1px 2px rgba(0,0,0,0.04)"
  },
  signatureImg: {
    maxWidth: "90%",
    maxHeight: 110,
    objectFit: "contain",
    filter: "drop-shadow(0 1px 1px rgba(0,0,0,0.06))"
  },
  signatureEmpty: {
    fontSize: 13,
    color: "#64748b",
    background: "#fff",
    padding: "10px 12px",
    borderRadius: 12,
    border: "1px dashed #cbd5e1"
  }
}));
